<template>
    <div class="module-ages">
        <v-layout align-center>
            <v-layout class="label" align-center justify-center>
                <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_ages.png" />
                <span class="text">{{ $userData.age }}</span>
            </v-layout>
            <v-layout class="bar" align-center>
                <img v-for="age in [20,30,40,50,60,70]"
                     :key="age"
                     v-if="age<=$userData.age"
                     :class="age === 70 ? 'last': ''"
                     :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/indicator_ages${age === 70 ? '_last' : ''}.png`" />
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
    export default {
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .module-ages {
        width: 191px;
        margin-top: 15.8px;
        margin-left: 37.7px;
        display: inline-block;
    }

    .label {
        position: relative;
        width: 36.3px;

        .text {
            position: absolute;
            font-family: "5x5 Pixel", sans-serif;
            margin-top: 5px;
            padding-left: 2px;
            font-size: 16px;
        }
    }

    .bar {
        margin-left: 8px;
        width: 147px;
        height: 18px;
        background-image: url(https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_ages_bar.png);
        padding-left: 3px;

        img {
            width: 21px;
            height: 14px;

            &.last {
                width: 18px;
            }

            &+img {
                margin-left: 3px;
            }
        }
    }
</style>
